<template>
  <div class="site-page">
    <div class="section-header page-title mb-4">
      <h1>Aperçu de votre compte</h1>
      <AccountNumber />
    </div>
    <div class="row">
      <div class="col-12 col-lg-4">
        <AccountAmount />
        <ConsommationAccount
          :head="account_level_header"
          :consommation_account="account_level_datas"
          :on_loading="on_loading"
        />
        <ConsommationServices
          :head="service_level_header"
          :consommation_services="service_level_datas"
          :on_loading="on_loading"
        />
      </div>
      <div class="col-12 col-lg-8">
        <Factures />
        <Releves />
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from "@/components/business/skeleton";
import EmptyState from "@/components/business/emptyState";
import Factures from "@/components/business/Factures";
import Releves from "@/components/business/Releves";
import AccountNumber from "@/components/business/AccountNumber";
import AccountAmount from "@/components/business/AccountAmount";
import ConsommationAccount from "@/components/business/ConsommationAccount";
import ConsommationServices from "@/components/business/ConsommationServices";
import { subscriber } from "@/services/";
import _ from "lodash";
export default {
  name: "mtn-business",
  components: {
    Skeleton,
    EmptyState,
    Factures,
    Releves,
    AccountAmount,
    AccountNumber,
    ConsommationAccount,
    ConsommationServices,
  },
  data() {
    return {
      account_level_header: [],
      account_level_datas: [],
      service_level_header: [],
      service_level_datas: [],
      on_loading: true,
    };
  },
  created: async function () {
    this.loadLastMonthBillDatas();
  },
  methods: {
    async loadLastMonthBillDatas() {
      if (this.$store.state.core.business_account.account_number !== null) {
        await subscriber.business_last_month_bill().then((response) => {
          this.on_loading = false;
          if (_.isUndefined(response.error)) {
            if (!_.isNil(response.account_level)) {
              if (!_.isNil(response.account_level.attribute_name)) {
                this.account_level_header =
                  response.account_level.attribute_name;
              } else {
                return [];
              }
              if (!_.isNil(response.account_level.value)) {
                this.account_level_datas = response.account_level.value;
              } else {
                return [];
              }
            }
            if (!_.isNil(response.service_level)) {
              if (!_.isNil(response.service_level.service_details)) {
                if (
                  !_.isNil(
                    response.service_level.service_details.attribute_name
                  )
                ) {
                  this.service_level_header =
                    response.service_level.service_details.attribute_name;
                } else {
                  return [];
                }
                if (!_.isNil(response.service_level.service_details.value)) {
                  this.service_level_datas =
                    response.service_level.service_details.value;
                } else {
                  return [];
                }
              }
            }
          } else {
            return;
          }
        });
      } else {
        this.on_loading = false;
      }
    },
  },
  watch: {
    "$store.state.core.business_account.account_number"() {
      this.loadLastMonthBillDatas();
    },
  },
};
</script>
